export const buildClientNoteCreatePayload = (clientId, values = {}) => ({
  client_id: Number(clientId),
  note: String(values.note ?? "").trim(),
});

export const getClientNoteSubmitError = (action, fallback = "Unable to save note.") => {
  const payload = action?.payload;
  if (typeof payload === "string" && payload) return payload;
  if (typeof payload?.message === "string" && payload.message) return payload.message;
  if (typeof payload?.message?.message === "string" && payload.message.message) return payload.message.message;
  if (typeof action?.error?.message === "string" && action.error.message) return action.error.message;
  return fallback;
};

export const isClientNoteLocked = (note) => Boolean(note && note.is_locked);

export const unlockedClientNotes = (notes) =>
  Array.isArray(notes) ? notes.filter((note) => !isClientNoteLocked(note)) : [];
